import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, renderList as _renderList, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = ["content"]
const _hoisted_2 = ["content"]
const _hoisted_3 = ["content"]
const _hoisted_4 = ["content"]
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "view-panel__header" }
const _hoisted_7 = {
  id: "view-panel-body",
  class: "view-panel__body"
}
const _hoisted_8 = {
  ref: "filter",
  class: "estate-listing-filter"
}
const _hoisted_9 = { class: "estate-listing-filter__item" }
const _hoisted_10 = { class: "estate-listing-filter__item-label" }
const _hoisted_11 = { class: "estate-listing-filter__item-value" }
const _hoisted_12 = ["v-if"]
const _hoisted_13 = { class: "estate-listing-filter__item-label" }
const _hoisted_14 = { class: "estate-listing-filter__item-value" }
const _hoisted_15 = { class: "estate-listing-filter__item" }
const _hoisted_16 = { class: "pagination-simple" }
const _hoisted_17 = { class: "pagination-info" }
const _hoisted_18 = { class: "estate-listing-filter__item-label" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 0,
  class: "no-records"
}
const _hoisted_22 = { class: "flashmessage flash-danger" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "loading" }
const _hoisted_25 = { class: "loading is-mobile" }
const _hoisted_26 = {
  class: "form-field",
  id: "frm_estateFilter-adType-form-field"
}
const _hoisted_27 = { class: "form-label" }
const _hoisted_28 = { class: "buttons-group" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "form-field" }
const _hoisted_31 = { class: "form-label" }
const _hoisted_32 = { class: "form-field" }
const _hoisted_33 = { class: "form-label" }
const _hoisted_34 = {
  class: "form-field",
  id: "frm_estateFilter-estateSubType-form-field"
}
const _hoisted_35 = { class: "form-label" }
const _hoisted_36 = { class: "form-field" }
const _hoisted_37 = { class: "form-label" }
const _hoisted_38 = { class: "multiple-inputs" }
const _hoisted_39 = ["placeholder"]
const _hoisted_40 = ["placeholder"]
const _hoisted_41 = {
  class: "form-field",
  id: "frm_estateFilter-status"
}
const _hoisted_42 = { class: "form-label" }
const _hoisted_43 = { class: "form-field" }
const _hoisted_44 = { class: "form-label" }
const _hoisted_45 = { class: "multiple-inputs" }
const _hoisted_46 = ["placeholder"]
const _hoisted_47 = ["placeholder"]
const _hoisted_48 = { class: "form-field" }
const _hoisted_49 = { class: "form-label" }
const _hoisted_50 = { class: "multiple-inputs" }
const _hoisted_51 = ["placeholder"]
const _hoisted_52 = ["placeholder"]
const _hoisted_53 = { class: "form-field" }
const _hoisted_54 = { class: "form-label" }
const _hoisted_55 = { class: "checkbox" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_57 = { class: "checkbox" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_59 = { class: "checkbox" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_61 = { class: "form-field" }
const _hoisted_62 = { class: "form-label" }
const _hoisted_63 = { class: "checkbox" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_65 = { class: "checkbox" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_67 = {
  class: "form-field",
  id: "frm_estateFilter-status"
}
const _hoisted_68 = { class: "form-label" }
const _hoisted_69 = { class: "form-field" }
const _hoisted_70 = { class: "form-label" }
const _hoisted_71 = { class: "multiple-inputs" }
const _hoisted_72 = ["placeholder"]
const _hoisted_73 = ["placeholder"]
const _hoisted_74 = { class: "form-field" }
const _hoisted_75 = { class: "form-label" }
const _hoisted_76 = { class: "multiple-inputs" }
const _hoisted_77 = ["placeholder"]
const _hoisted_78 = ["placeholder"]
const _hoisted_79 = { class: "form-field" }
const _hoisted_80 = { class: "form-label" }
const _hoisted_81 = { class: "form-field" }
const _hoisted_82 = { class: "form-label" }
const _hoisted_83 = { class: "checkbox" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_85 = { class: "checkbox" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_87 = { class: "form-field" }
const _hoisted_88 = { class: "form-label" }
const _hoisted_89 = { class: "checkbox" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_91 = { class: "checkbox" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_93 = { class: "form-field" }
const _hoisted_94 = { class: "form-label" }
const _hoisted_95 = { class: "multiple-inputs" }
const _hoisted_96 = ["placeholder"]
const _hoisted_97 = ["placeholder"]
const _hoisted_98 = { class: "form-field" }
const _hoisted_99 = { class: "form-label" }
const _hoisted_100 = { class: "checkboxlist" }
const _hoisted_101 = { class: "checkbox" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_103 = { class: "checkbox" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_105 = { class: "checkbox" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_107 = { class: "checkbox" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_109 = {
  key: 3,
  class: "form-field"
}
const _hoisted_110 = { class: "form-label" }
const _hoisted_111 = { class: "radiolist" }
const _hoisted_112 = { class: "radio" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_114 = { class: "radio" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_116 = { class: "radio" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_118 = {
  key: 1,
  class: "form-field filter-toggle"
}
const _hoisted_119 = { class: "form-field" }
const _hoisted_120 = { class: "buttons-group fullwidth" }
const _hoisted_121 = {
  key: 0,
  class: "badge"
}
const _hoisted_122 = {
  key: 2,
  class: "form-field"
}
const _hoisted_123 = {
  key: 3,
  class: "location-active-agent"
}
const _hoisted_124 = ["value"]
const _hoisted_125 = { class: "contact-person__photo" }
const _hoisted_126 = { class: "contact-person__info" }
const _hoisted_127 = { class: "contact-person__name" }
const _hoisted_128 = {
  key: 0,
  class: "contact-person__logo"
}
const _hoisted_129 = { class: "contact-person__detail" }
const _hoisted_130 = { class: "num" }
const _hoisted_131 = { id: "mobile-help-panel" }
const _hoisted_132 = {
  id: "mobile-help-nav",
  class: "footer-sticky-content"
}
const _hoisted_133 = { class: "width-wrap" }
const _hoisted_134 = {
  key: 0,
  class: "badge"
}
const _hoisted_135 = /*#__PURE__*/_createElementVNode("div", { id: "footer-fix" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Head = _resolveComponent("Head")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_AdList = _resolveComponent("AdList")!
  const _component_AdListItem = _resolveComponent("AdListItem")!
  const _component_AdTable = _resolveComponent("AdTable")!
  const _component_FixedElement = _resolveComponent("FixedElement")!
  const _component_vue_progress_bar = _resolveComponent("vue-progress-bar")!
  const _component_MapSearch = _resolveComponent("MapSearch")!
  const _component_GoogleAutocomplete = _resolveComponent("GoogleAutocomplete")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FooterSticky = _resolveComponent("FooterSticky")!
  const _component_AdFilter = _resolveComponent("AdFilter")!

  return (_openBlock(), _createElementBlock("div", {
    id: "body",
    class: _normalizeClass(["template_estate-map", _ctx.layoutClass])
  }, [
    _createVNode(_component_Head, null, {
      default: _withCtx(() => [
        _createElementVNode("title", null, _toDisplayString(_ctx.windowTitle), 1),
        _createElementVNode("meta", {
          name: "og:title",
          content: _ctx.windowTitle
        }, null, 8, _hoisted_1),
        _createElementVNode("meta", {
          name: "og:description",
          content: _ctx.metaDescription
        }, null, 8, _hoisted_2),
        _createElementVNode("meta", {
          name: "description",
          content: _ctx.metaDescription
        }, null, 8, _hoisted_3),
        _createElementVNode("meta", {
          name: "keywords",
          content: _ctx.$t('AdSearch.keywords')
        }, null, 8, _hoisted_4),
        _createElementVNode("link", {
          rel: "canonical",
          href: _ctx.canonicalUrl
        }, null, 8, _hoisted_5)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: _ctx.withTransition ? 'custom-fade' : ''
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          id: "estate-view-panel",
          class: _normalizeClass(["view-panel", _ctx.viewClass])
        }, [
          _createElementVNode("h1", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.pageTitle), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('AdSearch.sort')) + ":", 1),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_multiselect, {
                    class: _normalizeClass(["multiselect-simple", { 'is-active': _ctx.sortBy && _ctx.sortBy.value !== _ctx.defaultSortBy }]),
                    modelValue: _ctx.sortBy,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sortBy) = $event)),
                    onSelect: _ctx.onSortBySelect,
                    disabled: _ctx.showTable,
                    preselectFirst: true,
                    options: _ctx.sortByTypes,
                    "show-labels": false,
                    searchable: false,
                    "allow-empty": false,
                    "track-by": "value",
                    label: "title"
                  }, {
                    singleLabel: _withCtx(({ option }) => [
                      _createElementVNode("span", null, _toDisplayString(option.title), 1),
                      _createElementVNode("i", {
                        class: _normalizeClass(option.icon)
                      }, null, 2)
                    ]),
                    option: _withCtx(({ option }) => [
                      _createElementVNode("span", null, _toDisplayString(option.title), 1),
                      _createElementVNode("i", {
                        class: _normalizeClass(option.icon)
                      }, null, 2)
                    ]),
                    _: 1
                  }, 8, ["class", "modelValue", "onSelect", "disabled", "options"])
                ])
              ]),
              _createElementVNode("div", {
                class: "estate-listing-filter__item",
                "v-if": _ctx.viewType != _ctx.mobileViewType
              }, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('AdSearch.view-type')) + ":", 1),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_multiselect, {
                    class: _normalizeClass(["multiselect-simple", { 'is-active': _ctx.viewType && _ctx.viewType.value !== _ctx.defaultViewType }]),
                    modelValue: _ctx.viewType,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.viewType) = $event)),
                    onSelect: _ctx.onViewTypeSelect,
                    preselectFirst: true,
                    options: _ctx.viewTypes,
                    "show-labels": false,
                    searchable: false,
                    "allow-empty": false,
                    "track-by": "value",
                    label: "title"
                  }, {
                    singleLabel: _withCtx(({ option }) => [
                      _createElementVNode("span", null, _toDisplayString(option.title), 1),
                      _createElementVNode("i", {
                        class: _normalizeClass(option.icon)
                      }, null, 2)
                    ]),
                    option: _withCtx(({ option }) => [
                      _createElementVNode("span", null, _toDisplayString(option.title), 1),
                      _createElementVNode("i", {
                        class: _normalizeClass(option.icon)
                      }, null, 2)
                    ]),
                    _: 1
                  }, 8, ["class", "modelValue", "onSelect", "options"])
                ])
              ], 8, _hoisted_12),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('pager.displays')) + ":", 1),
                    (_ctx.pagedList.currentCount === _ctx.pagedList.totalCount)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_19, _toDisplayString(_ctx.pagedList.currentCount), 1))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          innerHTML: _ctx.$t('pager.line', { currentCount: _ctx.pagedList.currentCount, totalCount: _ctx.pagedList.totalCount, page: _ctx.pagedList.page })
                        }, null, 8, _hoisted_20))
                  ]),
                  _createVNode(_component_Pagination, {
                    currentPage: _ctx.pagedList.page,
                    pageSize: _ctx.pagedList.pageSize,
                    currentCount: _ctx.pagedList.currentCount,
                    totalCount: _ctx.pagedList.totalCount,
                    simple: true,
                    onLoadPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.pageChangeHandle($event, false)))
                  }, _createSlots({ _: 2 }, [
                    (_ctx.showZoomAdsControls)
                      ? {
                          name: "buttons",
                          fn: _withCtx(() => [
                            _createElementVNode("button", {
                              class: "button button--zoom-in",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.zoomAdsIn()))
                            }),
                            _createElementVNode("button", {
                              class: "button button--zoom-out",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.zoomAdsOut()))
                            })
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["currentPage", "pageSize", "currentCount", "totalCount"])
                ])
              ])
            ], 512),
            (_ctx.isInitialized && _ctx.pagedList.data.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.no-ads')) + " ", 1),
                      (_ctx.isMobile || _ctx.hasFilter || _ctx.canUnzoom)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_23, [
                            (_ctx.isMobile)
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 0,
                                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.forceShowFilter && _ctx.forceShowFilter(...args)))
                                }, _toDisplayString(_ctx.$t('AdSearch.edit-filter')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.hasFilter)
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 1,
                                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clearFilter && _ctx.clearFilter(...args)))
                                }, _toDisplayString(_ctx.$t('AdSearch.clear-filter')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.canUnzoom)
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 2,
                                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.unzoomMap && _ctx.unzoomMap(...args)))
                                }, _toDisplayString(_ctx.$t('AdSearch.unzoom-map')), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.showTable)
              ? (_openBlock(), _createBlock(_component_AdList, {
                  key: 1,
                  class: _normalizeClass(["estate-listing", _ctx.adListClass]),
                  data: _ctx.pagedList.data,
                  selected: _ctx.highlighted,
                  onSelected: _ctx.onSelected,
                  onHover: _ctx.onHover,
                  ref: "estateListing",
                  viewType: _ctx.viewType
                }, null, 8, ["class", "data", "selected", "onSelected", "onHover", "viewType"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_FixedElement, {
                    ref: "tableHeader",
                    threshold: _ctx.$refs.filter && _ctx.$refs.filter.clientHeight,
                    scrollableElementId: 'view-panel-body',
                    onChange: _ctx.updateTableFixedStatus
                  }, {
                    default: _withCtx(() => [
                      (_ctx.selected)
                        ? (_openBlock(), _createBlock(_component_AdListItem, {
                            key: 0,
                            ad: _ctx.selected,
                            viewType: 'table'
                          }, null, 8, ["ad"]))
                        : _createCommentVNode("", true),
                      (_ctx.isTableHeaderFixed)
                        ? (_openBlock(), _createBlock(_component_AdTable, {
                            key: 1,
                            class: _normalizeClass(["estate-listing", _ctx.adListClass]),
                            onlyHeader: true
                          }, null, 8, ["class"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["threshold", "onChange"]),
                  (_ctx.$refs.tableHeader && _ctx.isTableHeaderFixed)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        style: _normalizeStyle({ height: _ctx.$refs.tableHeader.$el.clientHeight + 'px' })
                      }, null, 4))
                    : _createCommentVNode("", true),
                  _createVNode(_component_AdTable, {
                    id: "estate-listing-table",
                    class: _normalizeClass(["estate-listing", _ctx.adListClass]),
                    data: _ctx.pagedList.data,
                    selected: _ctx.highlighted,
                    onSortBy: _ctx.sortByColumn,
                    onSelected: _ctx.onSelected,
                    onHover: _ctx.onHover
                  }, null, 8, ["class", "data", "selected", "onSortBy", "onSelected", "onHover"])
                ], 64)),
            _createVNode(_component_Pagination, {
              currentPage: _ctx.pagedList.page,
              pageSize: _ctx.pagedList.pageSize,
              currentCount: _ctx.pagedList.currentCount,
              totalCount: _ctx.pagedList.totalCount,
              onLoadPage: _cache[8] || (_cache[8] = ($event: any) => (_ctx.pageChangeHandle($event, true)))
            }, null, 8, ["currentPage", "pageSize", "currentCount", "totalCount"])
          ])
        ], 2), [
          [_vShow, _ctx.showList]
        ])
      ]),
      _: 1
    }, 8, ["name"]),
    _withDirectives(_createElementVNode("div", {
      id: "estate-map",
      style: _normalizeStyle({ height: _ctx.mapHeightStyle }),
      class: _normalizeClass({ 'map-hidden': _ctx.isFullScreen || (_ctx.isMobile && _ctx.swipe !== 1) })
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_24, [
        _createVNode(_component_vue_progress_bar, { class: "progress-bar" }),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdSearch.loading')), 1)
      ], 512), [
        [_vShow, _ctx.RADON_LOADING_BAR.options.show]
      ]),
      (_ctx.isMapVisible)
        ? (_openBlock(), _createBlock(_component_MapSearch, {
            ref: "map",
            key: _ctx.mapId,
            mapId: _ctx.mapId,
            ads: _ctx.markers,
            polylines: _ctx.polylines,
            selected: _ctx.highlighted,
            isMobile: _ctx.isMobile,
            isVisible: _ctx.showMap,
            bounds: _ctx.bounds,
            zoom: _ctx.zoom,
            gestureHandling: 'greedy',
            onRerender: _cache[9] || (_cache[9] = ($event: any) => (_ctx.mapId = $event)),
            onBoundsChanged: _ctx.onBoundsChanged,
            onSelected: _ctx.onMapSelected
          }, null, 8, ["mapId", "ads", "polylines", "selected", "isMobile", "isVisible", "bounds", "zoom", "onBoundsChanged", "onSelected"]))
        : _createCommentVNode("", true)
    ], 6), [
      [_vShow, _ctx.showMap]
    ]),
    _withDirectives(_createElementVNode("form", {
      id: "estate-filter",
      class: "filter-form",
      onSubmit: _cache[48] || (_cache[48] = _withModifiers(($event: any) => (_ctx.filter(true)), ["prevent"])),
      autocomplete: "off"
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_25, [
        _createVNode(_component_vue_progress_bar, { class: "progress-bar" }),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdSearch.loading')), 1)
      ], 512), [
        [_vShow, _ctx.RADON_LOADING_BAR.options.show]
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('AdSearch.filter.adtype')) + ":", 1),
        _createElementVNode("div", _hoisted_28, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adTypes, (item) => {
            return (_openBlock(), _createElementBlock("button", {
              key: item.key,
              class: _normalizeClass(["button", { 'is-active': _ctx.queryParams.type === item.key, [`adtype-${item.key}`]: true }]),
              type: "button",
              onClick: ($event: any) => (_ctx.selectAdType(item.key))
            }, _toDisplayString(item.value), 11, _hoisted_29))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('AdSearch.filter.country')) + ":", 1),
        _createVNode(_component_multiselect, {
          id: "frm_estateFilter-country",
          class: _normalizeClass(["select--country", { 'is-active': _ctx.queryParams.countryCode && _ctx.queryParams.countryCode != _ctx.defaultCountry.key }]),
          modelValue: _ctx.country,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.country) = $event)),
          "track-by": "key",
          label: "value",
          "show-labels": false,
          options: _ctx.countries,
          searchable: true,
          "close-on-select": true,
          placeholder: _ctx.$t('AdSearch.choose-country'),
          multiple: false,
          "allow-empty": true
        }, {
          singleLabel: _withCtx(({ option }) => [
            _createElementVNode("span", {
              class: _normalizeClass('flag-country-' + option.key)
            }, null, 2),
            _createElementVNode("span", {
              class: _normalizeClass({ 'font-weight-bold': option.key === _ctx.defaultCountry.key })
            }, _toDisplayString(option.value), 3)
          ]),
          option: _withCtx(({ option }) => [
            _createElementVNode("span", {
              class: _normalizeClass('flag-country-' + option.key)
            }, null, 2),
            _createElementVNode("span", {
              class: _normalizeClass({ 'font-weight-bold': option.key === _ctx.defaultCountry.key })
            }, _toDisplayString(option.value), 3)
          ]),
          noResult: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('multiselect.no-result')), 1)
          ]),
          _: 1
        }, 8, ["class", "modelValue", "options", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('AdSearch.filter.location')) + ":", 1),
        _createVNode(_component_GoogleAutocomplete, {
          ref: "place",
          id: "frm_estateFilter-place",
          name: "frm_estateFilter-place",
          placeholder: _ctx.$t('AdSearch.filter.locationPlaceholder'),
          class: _normalizeClass(["form-control", { 'is-active': _ctx.place || _ctx.filterPlace }]),
          types: null,
          country: _ctx.country.key,
          onPlacechanged: _ctx.onPlaceChanged,
          modelValue: _ctx.locationFilterText,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.locationFilterText) = $event))
        }, null, 8, ["placeholder", "country", "onPlacechanged", "modelValue", "class"])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('AdSearch.filter.estatetype')) + ":", 1),
        _createVNode(_component_multiselect, {
          id: "frm_estateFilter-estateSubType",
          modelValue: _ctx.queryParams.estateFrontSubTypes,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.queryParams.estateFrontSubTypes) = $event)),
          class: _normalizeClass({ 'is-active': _ctx.queryParams.estateFrontSubTypes && this.queryParams.estateFrontSubTypes.length > 0 }),
          "track-by": "key",
          label: "value",
          "show-labels": false,
          options: _ctx.estateTypes,
          "group-values": "estateSubTypes",
          "group-label": "value",
          placeholder: _ctx.$t('AdSearch.filter.estatetypePlaceholder'),
          "group-select": true,
          searchable: !_ctx.isMobile,
          "close-on-select": true,
          multiple: true,
          "allow-empty": true
        }, {
          noResult: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('multiselect.no-result')), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "class", "options", "placeholder", "searchable"])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('AdSearch.filter.pricerange')) + ":", 1),
        _createElementVNode("div", _hoisted_38, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["form-control", { 'is-active': _ctx.queryParams.priceFrom }]),
            type: "number",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.queryParams.priceFrom) = $event)),
            placeholder: _ctx.$t('AdSearch.filter.from')
          }, null, 10, _hoisted_39), [
            [
              _vModelText,
              _ctx.queryParams.priceFrom,
              void 0,
              {
                number: true,
                lazy: true
              }
            ]
          ]),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["form-control", { 'is-active': _ctx.queryParams.priceTo }]),
            type: "number",
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.queryParams.priceTo) = $event)),
            placeholder: _ctx.$t('AdSearch.filter.to')
          }, null, 10, _hoisted_40), [
            [
              _vModelText,
              _ctx.queryParams.priceTo,
              void 0,
              {
                number: true,
                lazy: true
              }
            ]
          ])
        ])
      ]),
      (_ctx.isFilterExtended)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.isFlat)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('AdSearch.filter.status')) + ":", 1),
                    _createVNode(_component_multiselect, {
                      id: "frm_estateFilter-status",
                      modelValue: _ctx.queryParams.status,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.queryParams.status) = $event)),
                      class: _normalizeClass({ 'is-active': _ctx.queryParams.status }),
                      "track-by": "key",
                      label: "value",
                      "show-labels": false,
                      options: _ctx.statuses,
                      searchable: false,
                      "close-on-select": true,
                      placeholder: _ctx.$t('AdSearch.filter.choose-status'),
                      multiple: false,
                      "allow-empty": true
                    }, null, 8, ["modelValue", "class", "options", "placeholder"])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('AdSearch.filter.estatearea')) + ":", 1),
                    _createElementVNode("div", _hoisted_45, [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass(["form-control", { 'is-active': _ctx.queryParams.estateAreaFrom }]),
                        type: "number",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.queryParams.estateAreaFrom) = $event)),
                        placeholder: _ctx.$t('AdSearch.filter.from')
                      }, null, 10, _hoisted_46), [
                        [
                          _vModelText,
                          _ctx.queryParams.estateAreaFrom,
                          void 0,
                          {
                            number: true,
                            lazy: true
                          }
                        ]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass(["form-control", { 'is-active': _ctx.queryParams.estateAreaTo }]),
                        type: "number",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.queryParams.estateAreaTo) = $event)),
                        placeholder: _ctx.$t('AdSearch.filter.to')
                      }, null, 10, _hoisted_47), [
                        [
                          _vModelText,
                          _ctx.queryParams.estateAreaTo,
                          void 0,
                          {
                            number: true,
                            lazy: true
                          }
                        ]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t('AdSearch.filter.floor')) + ":", 1),
                    _createElementVNode("div", _hoisted_50, [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass(["form-control", { 'is-active': _ctx.queryParams.floorFrom }]),
                        type: "number",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.queryParams.floorFrom) = $event)),
                        placeholder: _ctx.$t('AdSearch.filter.from')
                      }, null, 10, _hoisted_51), [
                        [
                          _vModelText,
                          _ctx.queryParams.floorFrom,
                          void 0,
                          {
                            number: true,
                            lazy: true
                          }
                        ]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass(["form-control", { 'is-active': _ctx.queryParams.floorTo }]),
                        type: "number",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.queryParams.floorTo) = $event)),
                        placeholder: _ctx.$t('AdSearch.filter.to')
                      }, null, 10, _hoisted_52), [
                        [
                          _vModelText,
                          _ctx.queryParams.floorTo,
                          void 0,
                          {
                            number: true,
                            lazy: true
                          }
                        ]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.$t('AdSearch.filter.equipment')) + ":", 1),
                    _createElementVNode("label", _hoisted_55, [
                      _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.filter.hasBalconyLoggiaTerrace')) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        name: "frm_estateFilter-balcony",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.queryParams.hasBalconyLoggiaTerrace) = $event))
                      }, null, 512), [
                        [
                          _vModelCheckbox,
                          _ctx.queryParams.hasBalconyLoggiaTerrace,
                          void 0,
                          {
                            number: true,
                            lazy: true
                          }
                        ]
                      ]),
                      _hoisted_56
                    ]),
                    _createElementVNode("label", _hoisted_57, [
                      _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.filter.hasParkingPlace')) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        name: "frm_estateFilter-parking",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.queryParams.hasParkingPlace) = $event))
                      }, null, 512), [
                        [
                          _vModelCheckbox,
                          _ctx.queryParams.hasParkingPlace,
                          void 0,
                          {
                            number: true,
                            lazy: true
                          }
                        ]
                      ]),
                      _hoisted_58
                    ]),
                    _createElementVNode("label", _hoisted_59, [
                      _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.filter.hasCellar')) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        name: "frm_estateFilter-cellar",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.queryParams.hasCellar) = $event))
                      }, null, 512), [
                        [
                          _vModelCheckbox,
                          _ctx.queryParams.hasCellar,
                          void 0,
                          {
                            number: true,
                            lazy: true
                          }
                        ]
                      ]),
                      _hoisted_60
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.$t('AdSearch.filter.suitable-for')) + ":", 1),
                    _createElementVNode("label", _hoisted_63, [
                      _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.filter.hasSmokersAllowed')) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        name: "frm_estateFilter-garage",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.queryParams.hasSmokersAllowed) = $event))
                      }, null, 512), [
                        [
                          _vModelCheckbox,
                          _ctx.queryParams.hasSmokersAllowed,
                          void 0,
                          {
                            number: true,
                            lazy: true
                          }
                        ]
                      ]),
                      _hoisted_64
                    ]),
                    _createElementVNode("label", _hoisted_65, [
                      _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.filter.hasPetsAllowed')) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        name: "frm_estateFilter-cellar",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.queryParams.hasPetsAllowed) = $event))
                      }, null, 512), [
                        [
                          _vModelCheckbox,
                          _ctx.queryParams.hasPetsAllowed,
                          void 0,
                          {
                            number: true,
                            lazy: true
                          }
                        ]
                      ]),
                      _hoisted_66
                    ])
                  ])
                ], 64))
              : (_ctx.isHouse)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.$t('AdSearch.filter.status')) + ":", 1),
                      _createVNode(_component_multiselect, {
                        id: "frm_estateFilter-status",
                        modelValue: _ctx.queryParams.status,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.queryParams.status) = $event)),
                        class: _normalizeClass({ 'is-active': _ctx.queryParams.status }),
                        "track-by": "key",
                        label: "value",
                        "show-labels": false,
                        options: _ctx.statuses,
                        searchable: false,
                        "close-on-select": true,
                        placeholder: _ctx.$t('AdSearch.filter.choose-status'),
                        multiple: false,
                        "allow-empty": true
                      }, null, 8, ["modelValue", "class", "options", "placeholder"])
                    ]),
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.$t('AdSearch.filter.usefulArea')) + ":", 1),
                      _createElementVNode("div", _hoisted_71, [
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["form-control", { 'is-active': _ctx.queryParams.usefulAreaFrom }]),
                          type: "number",
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.queryParams.usefulAreaFrom) = $event)),
                          placeholder: _ctx.$t('AdSearch.filter.from')
                        }, null, 10, _hoisted_72), [
                          [
                            _vModelText,
                            _ctx.queryParams.usefulAreaFrom,
                            void 0,
                            {
                              number: true,
                              lazy: true
                            }
                          ]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["form-control", { 'is-active': _ctx.queryParams.usefulAreaTo }]),
                          type: "number",
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.queryParams.usefulAreaTo) = $event)),
                          placeholder: _ctx.$t('AdSearch.filter.to')
                        }, null, 10, _hoisted_73), [
                          [
                            _vModelText,
                            _ctx.queryParams.usefulAreaTo,
                            void 0,
                            {
                              number: true,
                              lazy: true
                            }
                          ]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t('AdSearch.filter.landArea')) + ":", 1),
                      _createElementVNode("div", _hoisted_76, [
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["form-control", { 'is-active': _ctx.queryParams.landAreaFrom }]),
                          type: "number",
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.queryParams.landAreaFrom) = $event)),
                          placeholder: _ctx.$t('AdSearch.filter.from')
                        }, null, 10, _hoisted_77), [
                          [
                            _vModelText,
                            _ctx.queryParams.landAreaFrom,
                            void 0,
                            {
                              number: true,
                              lazy: true
                            }
                          ]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["form-control", { 'is-active': _ctx.queryParams.landAreaTo }]),
                          type: "number",
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.queryParams.landAreaTo) = $event)),
                          placeholder: _ctx.$t('AdSearch.filter.to')
                        }, null, 10, _hoisted_78), [
                          [
                            _vModelText,
                            _ctx.queryParams.landAreaTo,
                            void 0,
                            {
                              number: true,
                              lazy: true
                            }
                          ]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t('AdSearch.filter.roomCount')) + ":", 1),
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass(["form-control", { 'is-active': _ctx.queryParams.roomCount }]),
                        type: "number",
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.queryParams.roomCount) = $event))
                      }, null, 2), [
                        [
                          _vModelText,
                          _ctx.queryParams.roomCount,
                          void 0,
                          {
                            number: true,
                            lazy: true
                          }
                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.$t('AdSearch.filter.equipment')) + ":", 1),
                      _createElementVNode("label", _hoisted_83, [
                        _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.filter.hasGarage')) + " ", 1),
                        _withDirectives(_createElementVNode("input", {
                          name: "frm_estateFilter-garage",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.queryParams.hasGarage) = $event))
                        }, null, 512), [
                          [
                            _vModelCheckbox,
                            _ctx.queryParams.hasGarage,
                            void 0,
                            {
                              number: true,
                              lazy: true
                            }
                          ]
                        ]),
                        _hoisted_84
                      ]),
                      _createElementVNode("label", _hoisted_85, [
                        _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.filter.hasCellar')) + " ", 1),
                        _withDirectives(_createElementVNode("input", {
                          name: "frm_estateFilter-cellar",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.queryParams.hasCellar) = $event))
                        }, null, 512), [
                          [
                            _vModelCheckbox,
                            _ctx.queryParams.hasCellar,
                            void 0,
                            {
                              number: true,
                              lazy: true
                            }
                          ]
                        ]),
                        _hoisted_86
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("label", _hoisted_88, _toDisplayString(_ctx.$t('AdSearch.filter.suitable-for')) + ":", 1),
                      _createElementVNode("label", _hoisted_89, [
                        _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.filter.hasSmokersAllowed')) + " ", 1),
                        _withDirectives(_createElementVNode("input", {
                          name: "frm_estateFilter-garage",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.queryParams.hasSmokersAllowed) = $event))
                        }, null, 512), [
                          [
                            _vModelCheckbox,
                            _ctx.queryParams.hasSmokersAllowed,
                            void 0,
                            {
                              number: true,
                              lazy: true
                            }
                          ]
                        ]),
                        _hoisted_90
                      ]),
                      _createElementVNode("label", _hoisted_91, [
                        _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.filter.hasPetsAllowed')) + " ", 1),
                        _withDirectives(_createElementVNode("input", {
                          name: "frm_estateFilter-cellar",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.queryParams.hasPetsAllowed) = $event))
                        }, null, 512), [
                          [
                            _vModelCheckbox,
                            _ctx.queryParams.hasPetsAllowed,
                            void 0,
                            {
                              number: true,
                              lazy: true
                            }
                          ]
                        ]),
                        _hoisted_92
                      ])
                    ])
                  ], 64))
                : (_ctx.isLand)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_93, [
                        _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.$t('AdSearch.filter.landArea')) + ":", 1),
                        _createElementVNode("div", _hoisted_95, [
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass(["form-control", { 'is-active': _ctx.queryParams.landAreaFrom }]),
                            type: "number",
                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.queryParams.landAreaFrom) = $event)),
                            placeholder: _ctx.$t('AdSearch.filter.from')
                          }, null, 10, _hoisted_96), [
                            [
                              _vModelText,
                              _ctx.queryParams.landAreaFrom,
                              void 0,
                              {
                                number: true,
                                lazy: true
                              }
                            ]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass(["form-control", { 'is-active': _ctx.queryParams.landAreaTo }]),
                            type: "number",
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.queryParams.landAreaTo) = $event)),
                            placeholder: _ctx.$t('AdSearch.filter.to')
                          }, null, 10, _hoisted_97), [
                            [
                              _vModelText,
                              _ctx.queryParams.landAreaTo,
                              void 0,
                              {
                                number: true,
                                lazy: true
                              }
                            ]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("label", _hoisted_99, _toDisplayString(_ctx.$t('AdSearch.filter.network-engineer')) + ":", 1),
                        _createElementVNode("div", _hoisted_100, [
                          _createElementVNode("label", _hoisted_101, [
                            _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.filter.hasWaterNetwork')) + " ", 1),
                            _withDirectives(_createElementVNode("input", {
                              name: "frm_estateFilter-water",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.queryParams.hasWaterNetwork) = $event))
                            }, null, 512), [
                              [
                                _vModelCheckbox,
                                _ctx.queryParams.hasWaterNetwork,
                                void 0,
                                {
                                  number: true,
                                  lazy: true
                                }
                              ]
                            ]),
                            _hoisted_102
                          ]),
                          _createElementVNode("label", _hoisted_103, [
                            _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.filter.hasGasNetwork')) + " ", 1),
                            _withDirectives(_createElementVNode("input", {
                              name: "frm_estateFilter-gas",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.queryParams.hasGasNetwork) = $event))
                            }, null, 512), [
                              [
                                _vModelCheckbox,
                                _ctx.queryParams.hasGasNetwork,
                                void 0,
                                {
                                  number: true,
                                  lazy: true
                                }
                              ]
                            ]),
                            _hoisted_104
                          ]),
                          _createElementVNode("label", _hoisted_105, [
                            _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.filter.hasElectricityNetwork')) + " ", 1),
                            _withDirectives(_createElementVNode("input", {
                              name: "frm_estateFilter-electricity",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.queryParams.hasElectricityNetwork) = $event))
                            }, null, 512), [
                              [
                                _vModelCheckbox,
                                _ctx.queryParams.hasElectricityNetwork,
                                void 0,
                                {
                                  number: true,
                                  lazy: true
                                }
                              ]
                            ]),
                            _hoisted_106
                          ]),
                          _createElementVNode("label", _hoisted_107, [
                            _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.filter.hasCanalizationNetwork')) + " ", 1),
                            _withDirectives(_createElementVNode("input", {
                              name: "frm_estateFilter-canalization",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.queryParams.hasCanalizationNetwork) = $event))
                            }, null, 512), [
                              [
                                _vModelCheckbox,
                                _ctx.queryParams.hasCanalizationNetwork,
                                void 0,
                                {
                                  number: true,
                                  lazy: true
                                }
                              ]
                            ]),
                            _hoisted_108
                          ])
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
            (!_ctx.isEstateAgencyMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                  _createElementVNode("label", _hoisted_110, _toDisplayString(_ctx.$t('AdSearch.filter.showAds')) + ":", 1),
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("label", _hoisted_112, [
                      _createTextVNode(_toDisplayString(_ctx.$t('select.all')) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        value: null,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.queryParams.isEstateAgency) = $event))
                      }, null, 512), [
                        [
                          _vModelRadio,
                          _ctx.queryParams.isEstateAgency,
                          void 0,
                          {
                            number: true,
                            lazy: true
                          }
                        ]
                      ]),
                      _hoisted_113
                    ]),
                    _createElementVNode("label", _hoisted_114, [
                      _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.filter.private-ads')) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        value: false,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.queryParams.isEstateAgency) = $event))
                      }, null, 512), [
                        [
                          _vModelRadio,
                          _ctx.queryParams.isEstateAgency,
                          void 0,
                          {
                            number: true,
                            lazy: true
                          }
                        ]
                      ]),
                      _hoisted_115
                    ]),
                    _createElementVNode("label", _hoisted_116, [
                      _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.filter.estate-agent-ads')) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        value: true,
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.queryParams.isEstateAgency) = $event))
                      }, null, 512), [
                        [
                          _vModelRadio,
                          _ctx.queryParams.isEstateAgency,
                          void 0,
                          {
                            number: true,
                            lazy: true
                          }
                        ]
                      ]),
                      _hoisted_117
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (!_ctx.isEstateAgencyMode || (this.queryParams.estateFrontSubTypes && this.queryParams.estateFrontSubTypes.length > 0))
        ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
            (!_ctx.isFilterExtended)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "button-toggle-show",
                  onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.filterToggle(true)))
                }, _toDisplayString(_ctx.$t('AdSearch.filter.show-extended-filter')), 1))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "button-toggle-hide",
                  onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.filterToggle(false)))
                }, _toDisplayString(_ctx.$t('AdSearch.filter.hide-extended-filter')), 1))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_119, [
        _createElementVNode("div", _hoisted_120, [
          _createElementVNode("button", {
            ref: "btnSearch",
            class: "button button--primary",
            type: "submit"
          }, _toDisplayString(_ctx.$t('AdSearch.filter.search')), 513),
          _createElementVNode("button", {
            class: _normalizeClass(["button button--default has-badge", { invisible: !_ctx.hasFilter }]),
            type: "button",
            onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.clearFilter && _ctx.clearFilter(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.filter.clear-filter')) + " ", 1),
            (_ctx.hasFilter)
              ? (_openBlock(), _createElementBlock("span", _hoisted_121, _toDisplayString(_ctx.filterCount), 1))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
            _createElementVNode("button", {
              type: "button",
              class: "button button--link icon-save",
              onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.showAdFilterModal = true))
            }, _toDisplayString(_ctx.$t('AdSearch.filter.save-filter')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.agentList && _ctx.agentList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('AdSearch.active-agents.title')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agentList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "contact-person",
                value: item.frontUserId,
                key: item.frontUserId
              }, [
                _createElementVNode("div", _hoisted_125, [
                  _createVNode(_component_ResizableImage, {
                    url: item.photoRelativeUrl,
                    placeholder: "img/no-photo-user.png",
                    width: 135,
                    height: 135,
                    alt: item.fullName
                  }, null, 8, ["url", "alt"])
                ]),
                _createElementVNode("div", _hoisted_126, [
                  _createElementVNode("div", _hoisted_127, _toDisplayString(item.fullName), 1),
                  (!_ctx.isEstateAgencyMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                        _createVNode(_component_ResizableImage, {
                          classes: "estate-agency-logo",
                          url: item.logoRelativeUrl,
                          placeholder: "img/no-logo-agency.png",
                          width: 80,
                          height: 45,
                          alt: "agency"
                        }, null, 8, ["url"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_129, [
                  _createVNode(_component_router_link, {
                    tag: "a",
                    class: "button",
                    to: { name: 'AdAgentList', params: { urlName: item.estateAgentUrlName } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.active-agents.ads')) + " ", 1),
                      _createElementVNode("span", _hoisted_130, _toDisplayString(item.adCount), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ], 8, _hoisted_124))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 544), [
      [_vShow, _ctx.showFilter]
    ]),
    (_ctx.isMobile && _ctx.isMounted)
      ? (_openBlock(), _createBlock(_component_FooterSticky, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_131, [
              _createElementVNode("div", _hoisted_132, [
                _createElementVNode("div", _hoisted_133, [
                  _createElementVNode("button", {
                    class: _normalizeClass([{ active: _ctx.swipe === 0 }, "show-list"]),
                    onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.forceShowList()))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.tabs.list')) + " ", 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", { pulsate: _ctx.totalCountChanged }])
                    }, _toDisplayString(_ctx.pagedList.totalCount > 999 ? '999+' : _ctx.pagedList.totalCount), 3)
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass([{ active: _ctx.swipe === 1 }, "show-map"]),
                    onClick: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => (_ctx.forceShowMap && _ctx.forceShowMap(...args)))
                  }, _toDisplayString(_ctx.$t('AdSearch.tabs.map')), 3),
                  _createElementVNode("button", {
                    class: _normalizeClass([{ active: _ctx.swipe === 2 }, "show-filter"]),
                    onClick: _cache[51] || (_cache[51] = 
//@ts-ignore
(...args) => (_ctx.forceShowFilter && _ctx.forceShowFilter(...args)))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('AdSearch.tabs.filter')) + " ", 1),
                    (_ctx.hasFilter)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_134, _toDisplayString(_ctx.filterCount), 1))
                      : _createCommentVNode("", true)
                  ], 2)
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isMounted)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: "#container"
        }, [
          _hoisted_135,
          (_ctx.showAdFilterModal)
            ? (_openBlock(), _createBlock(_component_AdFilter, {
                key: 0,
                adFilterId: _ctx.$route.query.adFilterId,
                title: this.adFilter.title,
                params: _ctx.getSearchParams(),
                frequencies: _ctx.adFilterFrequencies,
                onClose: _cache[52] || (_cache[52] = ($event: any) => (_ctx.showAdFilterModal = false))
              }, null, 8, ["adFilterId", "title", "params", "frequencies"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}